import { render, staticRenderFns } from "./ChildrenDependantsEstatePlanning.vue?vue&type=template&id=73bc30b1"
import script from "./ChildrenDependantsEstatePlanning.vue?vue&type=script&lang=js"
export * from "./ChildrenDependantsEstatePlanning.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports